import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const getItemmaster = (state) => {
  return axios.get(API + "contracts/itemmaster-edit/"+state+"/",{headers: authHeader(),});
};
const editItemmaster= (state,itemid,itemname,description,serial_number,year,manufacturer,model,
  make,
  date_place,
  life_in_months,
  netbookvalue,
  originalcost,
  status,
  item_type,
  category_id,
  sub_category_id
) => {
    return axios.post(API + "contracts/itemmaster-edit/" +state+"/", {
        itemid,
        itemname,
        description,
        serial_number,
        year,
        manufacturer,
        model,
        make,
        date_place,
        life_in_months,
        netbookvalue,
        originalcost,
        status,
        item_type,
        category_id,
        sub_category_id

    },{headers: authHeader(),});
  };
const EditItemMasterService = {
    getItemmaster,
    editItemmaster,
  };
  export default EditItemMasterService;